// Remove modal functionality and keep only the core features
// Casino data
const nzCasinos = [
    {
        id: 1,
        name: "SkyCity Auckland",
        address: "Victoria Street &, Federal Street, Auckland CBD, Auckland 1010",
        coordinates: { lat: -36.848460, lng: 174.762970 },
        rating: 4.5,
        distance: 0.1,
        hours: {
            regular: "24/7",
            holidays: "24/7 except Christmas Day"
        },
        games: ["slots", "table", "poker"],
        facilities: {
            parking: "Available",
            restaurant: "Multiple options",
            dressCode: "Smart casual",
            minAge: 20
        },
        promotions: ["$1 Minimum Deposit", "Loyalty Program", "Birthday Bonus"],
        reviews: 1250
    },
    {
        id: 2,
        name: "SkyCity Hamilton",
        address: "346 Victoria Street, Hamilton Central, Hamilton 3204",
        coordinates: { lat: -37.787140, lng: 175.282240 },
        rating: 4.2,
        distance: 0.3,
        hours: {
            regular: "24/7",
            holidays: "24/7 except Christmas Day"
        },
        games: ["slots", "table"],
        facilities: {
            parking: "Free parking",
            restaurant: "2 restaurants",
            dressCode: "Smart casual",
            minAge: 20
        },
        promotions: ["$1 Gaming Special", "Weekend Bonus"],
        reviews: 850
    },
    {
        id: 3,
        name: "Christchurch Casino",
        address: "30 Victoria Street, Christchurch Central City, Christchurch 8013",
        coordinates: { lat: -43.524620, lng: 172.633310 },
        rating: 4.3,
        distance: 0.2,
        hours: {
            regular: "11am - 3am",
            holidays: "Special holiday hours apply"
        },
        games: ["slots", "table", "poker"],
        facilities: {
            parking: "Valet available",
            restaurant: "Grand Café",
            dressCode: "Smart casual",
            minAge: 20
        },
        promotions: ["New Player Special", "$1 Table Games"],
        reviews: 920
    }
];

// Sample reviews data
const reviews = [
    {
        id: 1,
        name: "Michael Thompson",
        casino: "SkyCity Auckland",
        rating: 5,
        date: "2024-02-15",
        text: "Great experience with their $1 deposit promotion! The wagering requirements were fair compared to other casinos, and I managed to turn my small deposit into a decent win. Customer service was excellent.",
        sentiment: 0.8,
        source: "casino.guru"
    },
    {
        id: 2,
        name: "Sarah Wilson",
        casino: "Christchurch Casino",
        rating: 4,
        date: "2024-02-14",
        text: "The $1 minimum deposit option is perfect for casual players. While the game selection is slightly limited for minimum deposits, the overall experience was positive. Good value for money.",
        sentiment: 0.6,
        source: "askgamblers.com"
    },
    {
        id: 3,
        name: "David Chen",
        casino: "SkyCity Hamilton",
        rating: 3,
        date: "2024-02-13",
        text: "Mixed feelings about the $1 deposit offer. While it's a great way to start, the withdrawal process took longer than expected. Games run smoothly though.",
        sentiment: 0.1,
        source: "casino.guru"
    },
    {
        id: 4,
        name: "Emma Taylor",
        casino: "SkyCity Auckland",
        rating: 2,
        date: "2024-02-12",
        text: "The $1 deposit bonus had higher wagering requirements than advertised. Customer support was slow to respond to my concerns about withdrawal limits.",
        sentiment: -0.5,
        source: "askgamblers.com"
    },
    {
        id: 5,
        name: "James Anderson",
        casino: "Christchurch Casino",
        rating: 1,
        date: "2024-02-11",
        text: "Disappointed with the $1 deposit promotion. Very restrictive game selection and high wagering requirements made it impossible to withdraw any winnings.",
        sentiment: -0.9,
        source: "casino.guru"
    }
];

// Initialize chart variables
let bonusChart = null;
let wagerChart = null;

// Calculator functionality
function updateCalculations() {
    const deposit = Number(document.getElementById('deposit')?.value || 1);
    const bonus = Number(document.getElementById('bonus')?.value || 100);
    const wager = Number(document.getElementById('wager')?.value || 35);

    const bonusAmount = deposit * (bonus / 100);
    const totalPlayable = deposit + bonusAmount;
    const wageringRequired = totalPlayable * wager;

    // Update results display
    document.getElementById('results').innerHTML = `
        <div class="bg-white p-4 rounded-md shadow-sm">
            <p class="text-sm text-gray-500">Initial Deposit</p>
            <p class="text-xl font-bold text-blue-600">$${deposit.toFixed(2)}</p>
        </div>
        <div class="bg-white p-4 rounded-md shadow-sm">
            <p class="text-sm text-gray-500">Bonus Amount</p>
            <p class="text-xl font-bold text-green-600">$${bonusAmount.toFixed(2)}</p>
        </div>
        <div class="bg-white p-4 rounded-md shadow-sm">
            <p class="text-sm text-gray-500">Total Playable</p>
            <p class="text-xl font-bold text-blue-600">$${totalPlayable.toFixed(2)}</p>
        </div>
        <div class="bg-white p-4 rounded-md shadow-sm">
            <p class="text-sm text-gray-500">Wagering Required</p>
            <p class="text-xl font-bold text-red-600">$${wageringRequired.toFixed(2)}</p>
        </div>
    `;

    updateCharts(deposit, bonus, wager, totalPlayable);
}

function updateCharts(deposit, bonus, wager, totalPlayable) {
    const bonusCtx = document.getElementById('bonusChart');
    const wagerCtx = document.getElementById('wagerChart');

    if (!bonusCtx || !wagerCtx) return;

    // Clear existing charts
    if (bonusChart) bonusChart.destroy();
    if (wagerChart) wagerChart.destroy();

    // Create new charts
    bonusChart = new Chart(bonusCtx, {
        type: 'bar',
        data: {
            labels: ['Initial Deposit', 'After Bonus'],
            datasets: [{
                label: 'Amount ($)',
                data: [deposit, deposit * (1 + bonus/100)],
                backgroundColor: ['#2563eb', '#1e40af'],
            }]
        },
        options: {
            responsive: true,
            plugins: {
                title: {
                    display: true,
                    text: 'Bonus Impact Analysis'
                }
            }
        }
    });

    wagerChart = new Chart(wagerCtx, {
        type: 'pie',
        data: {
            labels: ['Playable Amount', 'Additional Wagering Required'],
            datasets: [{
                data: [totalPlayable, (totalPlayable * wager) - totalPlayable],
                backgroundColor: ['#2563eb', '#1e40af'],
            }]
        },
        options: {
            responsive: true,
            plugins: {
                title: {
                    display: true,
                    text: 'Wagering Requirements Breakdown'
                }
            }
        }
    });
}

// Casino filtering functionality
let selectedCity = '';
let activeFilter = 'all';

function updateCasinoList() {
    const filteredCasinos = nzCasinos.filter(casino => {
        if (selectedCity && !casino.address.includes(selectedCity)) return false;
        if (activeFilter !== 'all') {
            return casino.games.includes(activeFilter);
        }
        return true;
    });

    const casinoListElement = document.getElementById('casinoList');
    if (casinoListElement) {
        casinoListElement.innerHTML = filteredCasinos.map(casino => `
            <div class="border border-gray-200 rounded-lg p-6 hover:shadow-lg transition-shadow">
                <div class="flex justify-between items-start mb-4">
                    <h3 class="text-xl font-semibold text-blue-600">${casino.name}</h3>
                    <div class="text-yellow-500">
                        ${casino.rating} ⭐ (${casino.reviews})
                    </div>
                </div>

                <div class="mb-4">
                    <p class="text-gray-600 mb-1">${casino.address}</p>
                    <p class="text-green-600 text-sm font-medium">${casino.distance}km from city center</p>
                </div>

                <div class="grid grid-cols-2 gap-4 mb-4 pt-4 border-t border-gray-100">
                    <div>
                        <p class="text-gray-500 text-sm mb-1">Hours</p>
                        <p class="font-medium">${casino.hours.regular}</p>
                        <p class="text-sm text-gray-500">${casino.hours.holidays}</p>
                    </div>
                    <div>
                        <p class="text-gray-500 text-sm mb-1">Facilities</p>
                        <p class="font-medium">${casino.facilities.parking}</p>
                        <p class="font-medium">${casino.facilities.restaurant}</p>
                    </div>
                </div>

                <div class="flex flex-wrap gap-2">
                    ${casino.games.map(game => `
                        <span class="px-3 py-1 bg-gray-100 text-gray-600 rounded-full text-sm">
                            ${game.charAt(0).toUpperCase() + game.slice(1)}
                        </span>
                    `).join('')}
                    ${casino.promotions.map(promo => `
                        <span class="px-3 py-1 bg-blue-50 text-blue-600 rounded-full text-sm">
                            ${promo}
                        </span>
                    `).join('')}
                </div>
            </div>
        `).join('');
    }
}

function updateReviewsList() {
    const reviewsListElement = document.getElementById('reviewsList');
    if (reviewsListElement) {
        reviewsListElement.innerHTML = reviews.map(review => `
            <div class="border border-gray-200 rounded-lg p-6">
                <div class="flex justify-between items-start mb-4">
                    <div>
                        <h3 class="text-lg font-semibold">${review.name}</h3>
                        <p class="text-sm text-gray-500">${review.casino}</p>
                    </div>
                    <div class="text-yellow-500">
                        ${'⭐'.repeat(review.rating)}
                    </div>
                </div>
                <p class="text-gray-700 mb-4">${review.text}</p>
                <div class="flex justify-between items-center">
                    <div class="flex items-center gap-2">
                        <div class="w-4 h-4 ${getSentimentClass(review.sentiment)} rounded"></div>
                        <span class="text-sm text-gray-600">Sentiment: ${getSentimentLabel(review.sentiment)}</span>
                    </div>
                    <div class="text-sm text-gray-500">
                        Source: ${review.source}
                    </div>
                </div>
            </div>
        `).join('');
    }
}

function getSentimentClass(sentiment) {
    if (sentiment >= 0.7) return 'bg-green-100 border-2 border-green-500';
    if (sentiment >= 0.3) return 'bg-blue-100 border-2 border-blue-500';
    if (sentiment >= -0.3) return 'bg-gray-100 border-2 border-gray-500';
    if (sentiment >= -0.7) return 'bg-orange-100 border-2 border-orange-500';
    return 'bg-red-100 border-2 border-red-500';
}

function getSentimentLabel(sentiment) {
    if (sentiment >= 0.7) return 'Very Positive';
    if (sentiment >= 0.3) return 'Positive';
    if (sentiment >= -0.3) return 'Neutral';
    if (sentiment >= -0.7) return 'Negative';
    return 'Very Negative';
}

// Event listeners
document.addEventListener('DOMContentLoaded', () => {
    // Calculator listeners
    document.getElementById('deposit')?.addEventListener('input', updateCalculations);
    document.getElementById('bonus')?.addEventListener('input', updateCalculations);
    document.getElementById('wager')?.addEventListener('input', updateCalculations);

    // Casino filter listeners
    document.getElementById('citySelect')?.addEventListener('change', (e) => {
        selectedCity = e.target.value;
        updateCasinoList();
    });

    document.getElementById('filters')?.addEventListener('click', (e) => {
        if (e.target.hasAttribute('data-filter')) {
            const newFilter = e.target.getAttribute('data-filter');
            
            // Update active state
            document.querySelectorAll('[data-filter]').forEach(btn => {
                if (btn.getAttribute('data-filter') === newFilter) {
                    btn.classList.remove('text-blue-600', 'hover:bg-blue-50');
                    btn.classList.add('bg-blue-600', 'text-white');
                } else {
                    btn.classList.add('text-blue-600', 'hover:bg-blue-50');
                    btn.classList.remove('bg-blue-600', 'text-white');
                }
            });
            
            activeFilter = newFilter;
            updateCasinoList();
        }
    });

    // Review form listener
    document.getElementById('reviewForm')?.addEventListener('submit', (e) => {
        e.preventDefault();
        const successMessage = document.getElementById('reviewSuccess');
        if (successMessage) {
            successMessage.classList.remove('hidden');
            setTimeout(() => {
                successMessage.classList.add('hidden');
                e.target.reset();
            }, 3000);
        }
    });

    // Set current year in footer
    const currentYearElement = document.getElementById('currentYear');
    if (currentYearElement) {
        currentYearElement.textContent = new Date().getFullYear();
    }

    // Initial render
    updateCalculations();
    updateCasinoList();
    updateReviewsList();
});